import { FragmentRESTSerializer as RESTSerializer } from 'ember-data-model-fragments/serializer';

export default class Base extends RESTSerializer {
  payloadKeyFromModelName(modelName) {
    return super.payloadKeyFromModelName(modelName).replace(/^media\//, '');
  }

  modelNameFromPayloadKey(key) {
    if (key === 'people') {
      return super.modelNameFromPayloadKey('person');
    }
    return super.modelNameFromPayloadKey('media/' + key);
  }
}
